




























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { FacilityModule } from '@/store/modules/facility.module'
import Table from '@/components/tables/Table.vue'
import { getModule } from 'vuex-module-decorators'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Card from '@/components/Card.vue'
import { GetFacilityCredentialsFilters, IFacilityCredentials, IFacility, sleepMs } from '@zunta/configurations'
import { Debounce } from 'vue-debounce-decorator'
import Icon from '@/components/Icon.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputPassword from '@/components/inputsV2/InputPassword.vue'
import Editable from '@/components/inputsV2/Editable.vue'

@Component({
  name: 'FacilityCredentialsModal',
  components: {
    Table,
    Card,
    ModalV2,
    Icon,
    InputV2,
    InputPassword,
    Editable,
  }
})
export default class FacilityCredentialsModal extends Vue {
  isLoading: boolean = false
  isEditLoading: boolean = false
  reloadTableKey = 0
  tooltipText = 'Click to Copy'
  showEditCredentialsModal = false
  facilityCredentialsToEdit: Partial<IFacilityCredentials> | null = null
  newPassword = ''
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  filters: GetFacilityCredentialsFilters = {
    skip: 0,
    limit: 20,
  }

  config: ITableConfig = {
    usePagination: true,
    fetchFunction: this.facilityModuleInstance.getPccFacilityCredentialsList,
    maxHeight: 'calc(100vh - 388px)',
    minHeight: '100px',
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    columns: [
      {
        minWidth: '300px',
        key: 'username',
        searchKey: 'username',
        hasSearch: true,
        hasSort: true,
        label: 'Username',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '200px',
        width: 10,
        key: 'password',
        searchKey: 'password',
        label: 'Password',
        type: ETableColumnType.default
      },
      {
        minWidth: '140px',
        width: 14,
        key: 'mfa',
        searchKey: 'withMfa',
        hasSearch: true,
        hasSort: true,
        label: 'MFA',
        type: ETableColumnType.select,
        options: [
          {
            key: 'Enabled',
            value: true,
            content: 'Enabled'
          },
          {
            key: 'Disabled',
            value: false,
            content: 'Disabled'
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '40px',
        width: 4,
        key: 'actions'
      }
    ]
  }

  get facilityCredentialsList () {
    return this.facilityModuleInstance.facilityCredentialsList
  }

  get facilityCredentialsTotal () {
    return this.facilityModuleInstance.facilityCredentialsTotal
  }

  editFacilityCredentials (item: Partial<IFacilityCredentials>) {
    this.showEditCredentialsModal = true
    this.facilityCredentialsToEdit = item
  }

  stopEditFacilityCredentials () {
    this.showEditCredentialsModal = false
    this.facilityCredentialsToEdit = null
    this.newPassword = ''
  }

  async saveEdits () {
    if (!this.facilityCredentialsToEdit) { return }
    if (!this.newPassword || this.newPassword === this.facilityCredentialsToEdit.password) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `Error`,
        message: `New password can’t be blank or reused`,
        icon: 'warning'
      })
      return
    }

    this.isEditLoading = true
    const response = await this.facilityModuleInstance.updateFacilityCredentials({
      ...this.facilityCredentialsToEdit,
      password: this.newPassword,
    })
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `Error`,
        message: response.message,
        icon: 'warning'
      })
      this.newPassword = ''
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Saved & Logged into PCC successfully',
        header: 'Success',
        icon: 'warning'
      })
      this.stopEditFacilityCredentials()
      this.reloadTableKey++
    }
    this.isEditLoading = false
  }

  @Debounce(300)
  async getOTPCode (facilityCredentials: Partial<IFacilityCredentials>) {
    if (!facilityCredentials.mfaSecret || !facilityCredentials.username) {
      return
    }
    this.tooltipText = 'Request in progress'
    const useFacilityCredentialsTable = true
    const response = await this.facilityModuleInstance.getOTPCodeForUsername(facilityCredentials.username)
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `OTP Error`,
        message: response.message,
        icon: 'warning'
      })
    } else {
      navigator.clipboard.writeText(String(response))
      this.tooltipText = 'Copied to Clipboard'
      setTimeout(() => {
        this.tooltipText = 'Click to Copy'
      }, 500)
    }
  }

  copyText (text: string) {
    navigator.clipboard.writeText(text)
    this.tooltipText = 'Copied to Clipboard'

    setTimeout(() => {
      this.tooltipText = 'Click to Copy'
    }, 500)
  }
}

